import { AbsenceOrigin } from '@bp/bp-graphql-types';
import i18next from 'i18next';

export function getAbsenceOriginTranslation(origin: AbsenceOrigin): string {
  switch (origin) {
    case AbsenceOrigin.Self:
      return i18next.t('absences.origin.self');
    case AbsenceOrigin.Parent:
      return i18next.t('absences.origin.parent');
    case AbsenceOrigin.SchoolOffice:
      return i18next.t('absences.origin.schoolOffice');
    case AbsenceOrigin.Classbook:
      return i18next.t('absences.origin.classbook');
    default:
      return '';
  }
}
